import { render } from "./SocialApp.vue?vue&type=template&id=4422daff"
import script from "./SocialApp.vue?vue&type=script&lang=js"
export * from "./SocialApp.vue?vue&type=script&lang=js"

import "./SocialApp.vue?vue&type=style&index=0&id=4422daff&lang=css"

import exportComponent from "/home/nimens/projects/cafe-portos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__